var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register page"},[_c('loginComp',{attrs:{"title":"Register Page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }